import { useMutation, useQuery } from "@tanstack/react-query";

import { queryClient } from "App";
import { caseKeys } from "routes/case/queryKeys";
import CaseService from "services/Case";

// ["case", id] covers the record page queries, whose keys also carry the
// disabled-tags filter. Those pages key by the URL segment, so the id is
// matched as a string. ["entity"] covers the record page's entity, which the
// case may have just left or joined, and onto which the API copies the case's
// addresses and websites.
const invalidateCase = (_, { id }) =>
  Promise.all([
    queryClient.invalidateQueries({ queryKey: ["case", String(id)] }),
    queryClient.invalidateQueries({ queryKey: ["entity"] }),
    queryClient.invalidateQueries({ queryKey: caseKeys.all }),
  ]);

// The "form" segment keeps this entry apart from the record page's
// ["case", id, showDisabledTags] query, which seeds placeholder initial data.
export const useCase = id =>
  useQuery({
    queryKey: ["case", id, "form"],
    queryFn: () => CaseService.get(id),
    enabled: !!id,
    retry: false,
  });

export const useCaseMutations = () => {
  const update = useMutation({
    mutationFn: ({ id, data }) => CaseService.update(id, data),
    onSuccess: invalidateCase,
  });

  return { update };
};
